import { render, staticRenderFns } from "./DeptRoleUserModal.vue?vue&type=template&id=674fcdf2&scoped=true"
import script from "./DeptRoleUserModal.vue?vue&type=script&lang=js"
export * from "./DeptRoleUserModal.vue?vue&type=script&lang=js"
import style0 from "./DeptRoleUserModal.vue?vue&type=style&index=0&id=674fcdf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674fcdf2",
  null
  
)

export default component.exports